/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';
import CustomModal from '../CustomModal/CustomModal';
import { Grid, Box, Typography } from '@mui/material';

import _ from 'lodash';
import Compdirection from '../../themes/CompDirection';
import { fonts, themes } from '../../themes/themes';
import { DataGrid } from '@mui/x-data-grid';
import './CheckinCheckoutModal.css';
import { useTranslation } from 'react-i18next';
import { useTranslate } from '../../../hooks';
import { arabicDataGrid, baseTimeFormatting } from '../../helper';
import { DateField } from '../../../components';

interface ModalProps {
  isModalOpen?: boolean;
  closeModal: any;
  trans?: any;
  attendanceData?: any;
}

const CheckInCheckoutModalPresenter = ({
  isModalOpen,
  closeModal,

  trans,
  attendanceData,
}: ModalProps) => {
  const { i18n } = useTranslation();
  const [temp_checkIn, settemp_checkIn] = useState<any>([]);
  const [temp_checkOut, settemp_checkOut] = useState<any>([]);

  const device = (key: string) => {
    switch (key) {
      case 'D':
        return 'Biometric';
      case 'M':
        return 'Mobile';
      case 'B':
        return 'Employee Portal';
      case 'Mark_att':
        return 'Mark Attendance';
      case 'Atten_excep':
        return 'Attendance Exception';
      case 'Bluk_Mark_att':
        return 'Bulk Mark Attendance';
      default:
        return key;
    }
  }
  useEffect(() => {
    if (attendanceData?.checkIn_checkOut?.length > 0) {
      const IN: any = [];
      const OUT: any = [];
      _.map(attendanceData?.checkIn_checkOut, (data: any) => {
        const _checkIn: any = {
          id: data?.employee_id,
          in_time: data?.clock_in ? data?.clock_in : '',
          in_from: data?.location_type_name ? data?.location_type_name : '--',
          in_location: data?.location ? data?.location : '--',
          in_note: data?.note ? data?.note : '--',
          timezoneOffset: attendanceData?.timezoneOffset,
          checkin_device: data?.checkin_device,
          markattendance: data?.markattendance,
        };

        IN.push(_checkIn);
        const _checkOut: any = {
          id: data?.employee_id,
          from_time: data?.clock_out ? data?.clock_out : '',
          from_from: data?.location_type_name ? data?.location_type_name : '--',
          from_location: data?.checked_out_location
            ? data?.checked_out_location
            : '--',
          from_note: data?.note ? data?.note : '--',
          timezoneOffset: attendanceData?.timezoneOffset,
          checkout_device: data?.checkout_device,
          markattendance: data?.markattendance,
        };

        OUT.push(_checkOut);
      });
      settemp_checkIn(IN);

      settemp_checkOut(OUT);
    }
  }, [attendanceData]);

  const rowDataCheckIn: any = _.map(temp_checkIn, (data: any, index) => {
    const rowData: any = {
      id: index,
      check_in: data?.in_time,
      check_in_location: data?.in_location,
      note: data?.in_note,
      timezoneOffset: data?.timezoneOffset,
      check_in_device: data?.checkin_device && !data?.markattendance
        ? device(data?.checkin_device)
        : device(data?.markattendance),
    };
    return rowData;
  });

  const rowDataCheckOut: any = _.map(temp_checkOut, (data: any, index) => {
    const rowData: any = {
      id: index,
      check_out: data?.from_time,
      check_out_location: data?.from_location,
      note: data?.from_note,
      timezoneOffset: data?.timezoneOffset,
      check_out_device: data?.checkout_device && !data?.markattendance
        ? device(data?.checkout_device)
        : device(data?.markattendance),
    };
    return rowData;
  });

  const tableColumns: any = [
    {
      field: 'check_in',
      headerName: trans('Check-In'),
      width: 160,
      headerClassName: 'header',
      height: 70,
      flex: 1,
      renderCell: (params: any) => {
        return params?.row.check_in ? (
          <DateField
            value={params?.row.check_in}
            format={baseTimeFormatting}
            offset={params?.row?.timezoneOffset}
          />
        ) : (
          '--'
        );
      },
    },
    {
      field: 'check_in_location',
      headerName: trans('Check-in Location'),
      width: 140,
      headerClassName: 'header',
      height: 70,
      flex: 1,
    },
    {
      field: 'check_in_device',
      headerName: trans('Check-in Device'),
      width: 140,
      headerClassName: 'header',
      height: 70,
      flex: 1,
    },
    {
      field: 'note',
      headerName: trans('Note'),
      width: 140,
      headerClassName: 'header',
      height: 70,
      flex: 1,
    },
  ];
  const tableColumnsCheckout: any = [
    {
      field: 'check_out',
      headerName: trans('Check-Out'),
      width: 160,
      headerClassName: 'header',
      height: 70,
      flex: 1,
      renderCell: (params: any) => {
        return params?.row.check_out ? (
          <DateField
            value={params?.row.check_out}
            format={baseTimeFormatting}
            offset={params?.row?.timezoneOffset}
          />
        ) : (
          '--'
        );
      },
    },
    {
      field: 'check_out_location',
      headerName: trans('Check-Out Location'),
      width: 140,
      headerClassName: 'header',
      height: 70,
      flex: 1,
    },
    {
      field: 'check_out_device',
      headerName: trans('Check-Out Device'),
      width: 140,
      headerClassName: 'header',
      height: 70,
      flex: 1,
    },
    {
      field: 'note',
      headerName: trans('Note'),
      width: 140,
      headerClassName: 'header',
      height: 70,
      flex: 1,
    },
  ];

  const { isRTL } = useTranslate();

  return (
    <CustomModal
      isModalOpen={isModalOpen}
      modalHeight="554px"
      modalWidth="80vw"
      overflowY="auto"
    >
      <Grid container style={{ flex: '1' }}>
        <Grid item xs={6} style={{ display: 'flex' }}>
          <span style={{ marginRight: '1em', cursor: 'pointer' }}>
            <Compdirection>
              <i
                className={
                  i18n.language == 'ar'
                    ? 'las la-long-arrow-alt-right'
                    : 'las la-long-arrow-alt-left'
                }
                onClick={() => {
                  closeModal();
                }}
                style={{ color: themes.greyDefault_500, fontSize: '1.5em' }}
              />
            </Compdirection>
          </span>
          <Typography
            style={{
              fontFamily: fonts.fontFamily,

              fontSize: fonts.title,
              fontWeight: 'bold',
            }}
          >
            <span
              style={{ color: themes.greyDefault_500, fontWeight: 'bold' }}
            ></span>
          </Typography>
        </Grid>
        <Grid
          item
          xs={6}
          style={{
            display: 'flex',
            alignItems: 'flex-end',
            justifyContent: 'flex-end',
          }}
        ></Grid>
      </Grid>
      <Compdirection>
        <Grid
          container
          spacing={2}
          style={{
            marginTop: '10px',
          }}
        >
          <Grid item xs={6}>
            <Box
              style={{
                width: 'auto',
                height: 'auto',
                padding: '28px',
                maxHeight: '534px',
                background: '#ffffff 0% 0% no-repeat padding-box',
                border: '1px solid #0000001f',
                borderRadius: '15px',
                overflowY: 'auto',
              }}
            >
              <div className="attendance_table">
                <DataGrid
                  sx={{
                    color: '#081735',
                    font: 'normal normal normal 14px/24px Lato;',
                  }}
                  autoHeight
                  disableExtendRowFullWidth
                  disableSelectionOnClick
                  localeText={isRTL ? arabicDataGrid : undefined}
                  disableColumnMenu
                  rows={rowDataCheckIn}
                  columns={tableColumns}
                  componentsProps={{
                    pagination: {
                      labelRowsPerPage: trans('Rows per page'),
                    },
                  }}
                />
              </div>
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box
              style={{
                width: 'auto',
                height: 'auto',
                padding: '28px',
                maxHeight: '534px',
                background: '#ffffff 0% 0% no-repeat padding-box',
                border: '1px solid #0000001f',
                borderRadius: '15px',
                overflowY: 'auto',
              }}
            >
              <div className="attendance_table">
                <DataGrid
                  sx={{
                    color: '#081735',
                    font: 'normal normal normal 14px/24px Lato;',
                  }}
                  autoHeight
                  disableExtendRowFullWidth
                  disableSelectionOnClick
                  disableColumnMenu
                  localeText={isRTL ? arabicDataGrid : undefined}
                  rows={rowDataCheckOut}
                  columns={tableColumnsCheckout}
                  componentsProps={{
                    pagination: {
                      labelRowsPerPage: trans('Rows per page'),
                    },
                  }}
                />
              </div>
            </Box>
          </Grid>
        </Grid>
      </Compdirection>
    </CustomModal>
  );
};
export default CheckInCheckoutModalPresenter;
